import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box, Divider } from '@material-ui/core';
import { helpStyles } from '../Help';
import srcSelectMenu from '../../../img/help/help_select_menu.jpg';
import srcBusinessJobMenu from '../../../img/help/help_business_job_menu.jpg';
import srcBusinessJobAdd from '../../../img/help/help_business_job_add.jpg';

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    ...helpStyles,
}));

const HelpBusinessJobEdit = () => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Typography variant="body1" className={classes.helpLine}>
                ・画面右上、メニューをクリックまたはタップします
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcSelectMenu} alt="Select menu" className={classes.helpImageStyle} />
            </Box>

            <Divider className={classes.helpDivider} />

            <Typography variant="body1" className={classes.helpLine}>
                ・メニューから『求人投稿・編集』を選択し、編集ページへ移動します。
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcBusinessJobMenu} alt="Business job menu" className={classes.helpImageStyle} />
            </Box>

            <Divider className={classes.helpDivider} />

            <Typography variant="body1" className={classes.helpLine}>
                『求人広告を作成する』ボタンをクリックし、編集ページへ移動します。
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcBusinessJobAdd} alt="Business job add" className={classes.helpImageStyle} />
            </Box>

            <Divider className={classes.helpDivider} />

            <Typography variant="body1" className={classes.helpParagraph}>
                メイン画像や求人の詳細等各項目を記入した後、画面下にある『求人を追加する』ボタンを押すと求人広告が投稿されます。
            </Typography>
            <Typography variant="body1" className={classes.helpParagraph}>
                求人広告の編集、削除、一時停止及び再開といった事も同ページから行う事ができます。
            </Typography>
        </Box>
    )
}

export default HelpBusinessJobEdit
